"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exhaustiveTypeException = exports.exhaustiveTypeCheck = exports.isInArray = void 0;
const isInArray = (value, array) => array.includes(value);
exports.isInArray = isInArray;
const exhaustiveTypeCheck = (_) => void _;
exports.exhaustiveTypeCheck = exhaustiveTypeCheck;
const exhaustiveTypeException = (type) => new Error(`Assertion failed: "unreachable" code reached with unknown type: ${typeof type === 'object' ? JSON.stringify(type) : String(type)}`);
exports.exhaustiveTypeException = exhaustiveTypeException;
